import React from "react";
import "./MenuLeft.css";

function MenuLeft() {
  return (
    <>
      <div className="firstMenu">
        <ul>
          <li>
            <a href="blank">
              <span>Our</span>World
            </a>
          </li>
          <li>
            <a href="blank">Models</a>
          </li>
          <li>
            <a href="blank">Owners</a>
          </li>
          <li>
            <a href="blank">
              <span>F1</span>team
            </a>
          </li>
        </ul>
      </div>
    </>
  );
}

export default MenuLeft;
